import React, { useEffect, useCallback, useState} from 'react';
import SourceResults from './SourceResults.js';
import DayResults from './DayResults.js';
import ContentGrid from './ContentGrid.js';
import SampleSearch from '../SampleSearch.js';
import {getPresets} from './getPresets.js';
import {connect} from 'react-redux';

const Presets = ({sequencerEngine}) => { 
    let [day, setDay] = useState(undefined);
    let [source, setSource] = useState(undefined);
    let [searchTerm, setSearchTerm] = useState('');
    let [loadEffects, setLoadEffects] = useState(true);
    let [loadMods, setLoadMods] = useState(true);

    let backButton = '';
    let results = '';
    if (day || source) {
        backButton = 
            (<div
              onClick={() => {setDay(undefined);  setSource(undefined);}}
               className="selector-back-button"/>);
        results = 
            source ? <SourceResults alone={true} sequencerEngine={sequencerEngine} source={source}/> :
        <DayResults sequencerEngine={sequencerEngine} day={day}/>;
        results =
            [(<div className="results-toolbar">
                <div className="settings-info">
                  Load preset with 
                </div>
                <div
                  onClick={() => setLoadEffects(!loadEffects)}
                  className={loadEffects ? "preset-setting selected" : "preset-setting"}>FX</div>
                <div
                  onClick={() => setLoadMods(!loadMods)}
                  className={loadMods ? "preset-setting selected" : "preset-setting"}>Mods</div>
              </div>),
             results];
         
    }

    const onChange = useCallback((s) => {
        setDay(undefined);
        setSource(undefined);
        setSearchTerm(s);
    }, [setSearchTerm]);

    const onClickSource = useCallback((source) => {
        setDay(undefined);
        setSource(source);
    }, [setDay, setSource]);

    const onClickDay = useCallback((day) => {
        setSource(undefined);
        setDay(day);
    }, [setSource, setDay]);

    return (
        <div className="new-selector presets">
          <div className="search-and-back">{backButton} <SampleSearch onChange={onChange}/></div>
        {results ? results : 
         <div className="selector-inner">
           <ContentGrid
             onClickSource={onClickSource}
             onClickDay={onClickDay}
             getContent={getPresets}
             searchTerm={searchTerm}
             sequencerEngine={sequencerEngine}/>
         </div>}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Presets);
